<template>
    <div>
        <b-row align-v="end">
            <b-col cols="6">
                <label>{{ title }}</label>
                <v-select :options="showListaProdutos" v-model="produto" @change="selectedProduto(produto)"
                    ref="produto" />
            </b-col>
            <b-col cols="2">
                <label for="">Qtd.</label>
                <!-- <b-form-input type="number" v-model="quantidade" @keyup.enter="addProduto" :disabled="getSaldo <= 0"></b-form-input> -->
                <b-form-input type="number" v-model="quantidade" @keyup.enter="addProduto"></b-form-input>
            </b-col>
            <b-col cols="2">
                <label for="" v-b-tooltip.hover title="Só é permitido informar um valor igual ou maior que o valor de tabela.">Valor Unit.</label>
                <b-form-input type="number" step="0.01" v-model="valorUnitario" @keyup.enter="addProduto"></b-form-input>
            </b-col>
            <b-col cols="1" v-if="brinde">
                <b-form-checkbox v-model="isBrinde" title="Brinde">
                    Brinde
                </b-form-checkbox>
            </b-col>
            <b-col cols="1">
                <!-- <b-button variant="success" @click="addProduto" class="mt-4" :disabled="getSaldo <= 0 || getSaldo < quantidade">
                    Adicionar
                </b-button> -->
                <b-button variant="success" @click="addProduto" class="mt-4">
                    Adicionar
                </b-button>
            </b-col>
        </b-row>
        <div class="row" v-if="showProdutoSelecionado">
            <div class="col text-primary">
                {{ produto.value.codigo }} - {{ produto.value.descricao }} ( R$
                {{ parseFloat(valorUnitarioAtual).toFixed(2) }} X {{ quantidade }} = {{
                    parseFloat(valorUnitarioAtual * quantidade).toFixed(2) }}) -
                <small class="text-danger"> <b> Saldo = {{ getSaldo }} </b></small>
                <small v-if="valorUnitarioAtual > parseFloat(produto.value.preco_venda)" class="text-success d-block">
                    <b>Acima da tabela</b> (Tabela: R$ {{ parseFloat(produto.value.preco_venda).toFixed(2) }})
                </small>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'busca-produto',
    props: {
        brinde: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "Produtos"
        },
        item: {
            type: Object
        },
        listaProdutos: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            produto: "",
            isBrinde: false,
            quantidade: 1,
            valorUnitario: null
        }
    },
    watch: {
        // "quantidade"(newValue) {
        //     if(this.produto && this.produto.value) {
        //         newValue = parseInt(newValue)
        //         let saldo = this.getSaldo;
        //         if (saldo <= 0 || newValue > saldo) {
        //             this.quantidade = '0';
        //         }
        //     }
        // },

        // produto(newValue) {
        //     if (newValue && this.item.quantidade > this.getSaldo) {
        //         this.item.quantidade = 0;
        //     }
        // }
    },

    computed: {
        getSaldo() {
            let saldo = 0
            if(this.produto && this.produto.value) {
                const qtdpedido = this.produto.value.qtd_pedido ? parseInt(this.produto.value.qtd_pedido) : 0
                const qtdproposta = this.produto.value.qtd_proposta ? parseInt(this.produto.value.qtd_proposta) : 0
                saldo = this.produto.value.estoque - (qtdpedido + qtdproposta);
            }
            return parseInt(saldo)
        },
        showListaProdutos() {
            let _produtos = [];
            if (this.listaProdutos.length > 0) {
                this.listaProdutos.map(el => {
                    const qtdpedido = el.qtd_pedido ? parseInt(el.qtd_pedido) : 0
                    const qtdproposta = el.qtd_proposta ? parseInt(el.qtd_proposta) : 0
                    let saldo = el.estoque - (qtdpedido + qtdproposta);
                    _produtos.push({
                        label: el.codigo + ' - ' + el.descricao + ' - Saldo = '+ saldo,
                        value: el
                    });
                })
            }
            return _produtos
        },
        showProdutoSelecionado() {
            let show = false;
            if (this.produto !== "" && this.produto) {
                show = true;
            }
            return show;
        },
        valorUnitarioAtual() {
            if (this.valorUnitario !== null && this.valorUnitario !== '') {
                return parseFloat(this.valorUnitario);
            }
            return this.produto && this.produto.value ? parseFloat(this.produto.value.preco_venda) : 0;
        }
    },
    methods: {
        selectedProduto(obj) {
            if (this.produto) {
                this.item.produto = obj ? obj.value : "";
                this.item.produto_id = obj ? obj.value.id : null;
                this.valorUnitario = obj ? parseFloat(obj.value.preco_venda) : null;
            } else {
                this.valorUnitario = null;
            }
        },
        // buscaProduto() {
        //     const vm = this;
        //     axios.get("/venda-direta/produtos/lista").then((response) => {
        //         vm.listaProdutos = response.data;
        //     }).catch((error) => {
        //         console.log("erro ao listar produtos ...", error);
        //     })
        // },
        addProduto() {
            if (this.produto === "") {
                return this.$swal("Ops", "Selecione antes um produto.", "error");
            }
            if (this.produto.value.preco_venda === 0) {
                return this.$swal("Ops", "Produto com preço zerado não poderá ser selecionado.", "error");
            }
            const valorTabela = parseFloat(this.produto.value.preco_venda);
            const valorInformado = this.valorUnitarioAtual;
            if (valorInformado < valorTabela) {
                return this.$swal("Ops", "O valor unitário não pode ser menor que o valor da tabela de preço (R$ " + valorTabela.toFixed(2).replace(".", ",") + ").", "error");
            }
            this.item.valor_unitario = valorInformado;
            this.item.valor_unitario_tabela = valorTabela;
            this.item.valor_total = parseFloat(this.quantidade * valorInformado);
            this.item.qtd_caixa = this.produto.value.qtd_caixa;
            this.item.brinde = this.isBrinde;
            this.item.preco_regular = this.produto.value.preco_regular;
            this.item.quantidade = parseInt(this.quantidade);
            this.produto = "";
            this.$emit("addProduto", this.item);
            this.quantidade = 1;
            this.valorUnitario = null;
        }
    },
    mounted() {
        //this.buscaProduto();
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/varejo/produtos/busca-produto.vue